module.exports = __webpack_public_path__ + "static/img/stay_success.65b10325.svg";